import React from "react";
import { Link } from "react-router-dom";

export default function About() {
  const processSteps = [
    { t: "Consult", d: "Begin with a conversation — fit, fabric, occasion." },
    { t: "Measure", d: "13 precise measurements, captured in-person or via guided self-measure." },
    { t: "Cut", d: "Cloth is hand-cut from our 200+ fabric library." },
    { t: "Stitch", d: "Master karigars stitch every seam with care." },
    { t: "Finish", d: "Quality check, monogramming, and pressing." },
    { t: "Deliver", d: "Shipped via concierge or picked up at our atelier." },
  ];
  return (
    <main data-testid="about-page">
      {/* Brand story narrative */}
      <section className="bg-black text-white">
        <div className="sq-container py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="sq-eyebrow text-white/60">Our Story</div>
            <h1 className="font-display text-5xl md:text-7xl mt-3 leading-[0.95]">A tailor's letter, in five chapters.</h1>
          </div>
          <div className="space-y-6 text-white/80">
            <p><strong className="text-white">Chapter I — Cloth.</strong> A bolt of linen from Belfast. A whisper of wool from Como. Cloth begins our story.</p>
            <p><strong className="text-white">Chapter II — Cut.</strong> We measure thirteen times. We cut once. The pattern is yours alone.</p>
            <p><strong className="text-white">Chapter III — Hand.</strong> Each garment passes through eight pairs of trained hands.</p>
            <p><strong className="text-white">Chapter IV — Fit.</strong> The first fitting. The second. The third, if you wish. We don't stop until it sits.</p>
            <p><strong className="text-white">Chapter V — You.</strong> A piece that holds its shape, holds its colour, holds its meaning.</p>
          </div>
        </div>
      </section>

      <section className="sq-container py-24 grid grid-cols-1 md:grid-cols-2 gap-12">
        <div>
          <div className="sq-eyebrow text-squire-jeans">Our Mission</div>
          <h2 className="font-display text-4xl mt-3">To make every man feel cut out for his moment.</h2>
        </div>
        <div>
          <div className="sq-eyebrow text-squire-jeans">Our Vision</div>
          <h2 className="font-display text-4xl mt-3">A wardrobe where nothing is borrowed, all of it is yours.</h2>
        </div>
      </section>

      {/* Wave process */}
      <section className="bg-[#FDFDFD] py-24" data-testid="about-process">
        <div className="sq-container">
          <div className="sq-eyebrow">The Process</div>
          <h2 className="font-display text-4xl md:text-6xl mt-3">From cloth to closet, six considered steps.</h2>
          <div className="mt-16 relative">
            <svg viewBox="0 0 1000 220" className="w-full h-40 md:h-56" preserveAspectRatio="none">
              <path d="M0,110 C150,30 300,190 500,110 C700,30 850,190 1000,110" fill="none" stroke="#0A0A0A" strokeWidth="2" />
            </svg>
            <div className="grid grid-cols-3 md:grid-cols-6 gap-4 -mt-12">
              {processSteps.map((s, i) => (
                <div key={i} className="text-center" data-testid={`process-step-${i}`}>
                  <div className="w-10 h-10 mx-auto bg-squire-jeans text-white flex items-center justify-center font-display text-lg rounded-full">{i + 1}</div>
                  <div className="font-display text-lg mt-3">{s.t}</div>
                  <div className="text-xs text-[#4B5563] mt-1">{s.d}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="mt-16 text-center">
            <Link to="/bespoke" className="sq-btn-primary">Begin Your Bespoke</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
